import { RefObject, useEffect } from "react";
import { useScrollStore } from "@/common/store/scrollStore";

interface IProps {
  scrollRef: RefObject<HTMLElement | null>;
}

export const useScrollElement = ({ scrollRef }: IProps) => {
  const setScrollElement = useScrollStore((state) => state.setScrollElement);

  useEffect(() => {
    setScrollElement(scrollRef.current);
  }, [scrollRef]);
};
